import { Splide } from '@hh/global.js'

if (!customElements.get('hotspots-wrapper')) {
  customElements.define(
    'hotspots-wrapper',
    class HotspotsWrapper extends HTMLElement {
      constructor() {
        super();
      }

      setVariables() {
        this.activeId = ''
        this.activeIndex = 0
        this.touchStartX = 0
        this.touchEndX = 0

        this.dots = this.querySelectorAll('.js-spot-dot')
        this.navDots = this.querySelectorAll('.js-nav-dot')
        this.navArrows = this.querySelectorAll('.js-nav-arrow')
        this.spotItems = this.querySelectorAll('.js-spot-item')
        this.dotsCount = parseInt(this.getAttribute('data-count') || '0')
      }

      connectedCallback() {
        this.setVariables()

        this.dots.forEach(dot => {
          dot.addEventListener('mouseenter', this.onMouseEntered.bind(this))
          dot.addEventListener('mouseleave', this.onMouseLeft.bind(this))
          dot.addEventListener('click', this.onClickedSpot.bind(this))
        })

        this.addEventListener('click', this.onWrapperClicked.bind(this));
        document.addEventListener('keydown', this.onDocumentKeyDown.bind(this))

        this.addEventListener('touchstart', this.onTouchStart.bind(this))
        this.addEventListener('touchend', this.onTouchEnd.bind(this))

        this.navDots.forEach(dot => {
          dot.addEventListener('click', this.onClickNavDot.bind(this))
        })

        this.navArrows.forEach(arrow => {
          arrow.addEventListener('click', this.onClickNavArrow.bind(this))
        })

        this.querySelectorAll('[data-spot-close]').forEach(closeBtn => {
          closeBtn.addEventListener('click', this.onCloseSpot.bind(this))
        })
      }

      disconnectedCallback() {
        this.setVariables()

        this.dots.forEach(dot => {
          dot.removeEventListener('mouseenter', this.onMouseEntered.bind(this))
          dot.removeEventListener('mouseleave', this.onMouseLeft.bind(this))
          dot.removeEventListener('click', this.onClickedSpot.bind(this))
        })

        this.removeEventListener('click', this.onWrapperClicked.bind(this));
        document.removeEventListener('keydown', this.onDocumentKeyDown.bind(this))

        this.removeEventListener('touchstart', this.onTouchStart.bind(this))
        this.removeEventListener('touchend', this.onTouchEnd.bind(this))

        this.navDots.forEach(dot => {
          dot.removeEventListener('click', this.onClickNavDot.bind(this))
        })

        this.navArrows.forEach(arrow => {
          arrow.removeEventListener('click', this.onClickNavArrow.bind(this))
        })

        this.querySelectorAll('[data-spot-close]').forEach(closeBtn => {
          closeBtn.removeEventListener('click', this.onCloseSpot.bind(this))
        })
      }

      onDocumentKeyDown(event) {
        if (event.key === 'Escape') this.onCloseSpot()
      }

      onWrapperClicked(event) {
        if (!event.target.closest('.js-spot-dot') &&
          !event.target.classList.contains('js-spot-dot') &&
          !event.target.closest('.js-spot-item') &&
          !event.target.closest('.hotspots-product__title') &&
          !event.target.closest('.hotspots-item') &&
          !event.target.closest('.hotspots-nav')
        ) this.onCloseSpot()
      }

      onTouchStart(event) {
        this.touchStartX = event.changedTouches[0].screenX
      }

      onTouchEnd(event) {
        this.touchEndX = event.changedTouches[0].screenX
        this.onSwipe()
      }

      onClickNavArrow(event) {
        const { direction } = event.currentTarget.dataset
        this.navMove(direction)
      }

      navMove(direction) {
        let targetIndex = (direction == 'next') ? this.activeIndex + 1 : this.activeIndex - 1
        if (targetIndex > this.dotsCount) targetIndex = 1
        if (targetIndex < 1) targetIndex = this.dotsCount
        const selector = `.js-spot-dot[data-index="${targetIndex}"]`
        const targetElement = this.querySelector(selector)
        if (targetElement) {
          this.removeClickedState()
          const { id } = targetElement.dataset
          this.activeId = id
          this.updateState()
        }
      }

      onSwipe(event) {
        if (!this.isMobile()) return
        if (this.touchEndX < this.touchStartX) {
          this.navMove('next')
        } else if (this.touchEndX > this.touchStartX) {
          this.navMove('prev')
        }
      }

      onClickNavDot(event) {
        this.removeClickedState()
        const { id } = event.currentTarget.dataset
        this.activeId = id
        this.updateState()
      }

      onClickedSpot(event) {
        event.stopPropagation()
        const { id } = event.currentTarget.dataset

        if (event.currentTarget.classList.contains('clicked')) {
          event.currentTarget.classList.remove('clicked')
          event.currentTarget.classList.remove('active')
          this.activeId = ''
        } else {
          this.removeClickedState()
          event.currentTarget.classList.add('clicked')
          event.currentTarget.classList.add('active')
          this.activeId = id
        }

        this.updateState()
      }

      onMouseEntered(event) {
        event.stopPropagation()
        if (!this.isMobile()) {
          const { id } = event.currentTarget.dataset
          if (this.activeId != id) this.removeClickedState()
          this.activeId = id
          this.updateState()
        }
      }

      onMouseLeft(event) {
        if (!this.isMobile() && !event.target.classList.contains('clicked')) {
          this.activeId = ''
          this.updateState()
        }
      }

      onCloseSpot() {
        this.activeId = ''
        this.removeClickedState()
        this.updateState()
      }

      removeClickedState() {
        this.dots.forEach(dot => dot.classList.remove('clicked'))
      }

      updateState() {
        this.dots.forEach(dot => {
          if (dot.getAttribute('data-id') == this.activeId) {
            this.activeIndex = parseInt(dot.getAttribute('data-index') || '0')
            dot.classList.add('active')
          } else {
            dot.classList.remove('active')
          }
        })

        this.navDots.forEach(dot => {
          dot.classList.toggle('active', dot.getAttribute('data-id') === this.activeId)
        })

        this.spotItems.forEach(item => {
          item.classList.toggle('active', item.getAttribute('data-id') == this.activeId)
          item.setAttribute('aria-hidden', item.getAttribute('data-id') !== this.activeId)
        })

        this.classList.toggle('hotspots--show-active', this.activeId)

        this.querySelectorAll('.js-title-carousel')
          .forEach(element => {
            element.querySelector('hotspots-carousel')?.goToIndex(this.activeIndex - 1)
            element.classList.toggle('active', this.activeId)
          })

        this.querySelectorAll('.js-details-carousel')
          .forEach(element => {
            element.querySelector('hotspots-carousel')?.goToIndex(this.activeIndex - 1)
            element.classList.toggle('active', this.activeId)
          })
      }

      isMobile () {
        return window.matchMedia("(max-width: 749px)").matches
      }
    }
  );
}

if (!customElements.get('hotspots-carousel')) {
  customElements.define(
    'hotspots-carousel',
    class HotspotsCarousel extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const slider = this.querySelector('.splide')
        if (slider) {
          this.initSlider(slider)
        }
      }

      initSlider(slider) {
        if (slider) {
          this.slider = new Splide(slider, {
            type: 'loop',
            arrows: false,
            drag: false,
            pagination: false,
          })
          this.slider.mount();
        }
      }

      goToIndex(index) {
        if (this.slider) this.slider.go(parseInt(index))
      }
    }
  );
}
